import React from "react";
import { useNavigate } from "react-router-dom";
import { closeModal } from "react-url-modal";
import { Portal, Button } from "@/components";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";
import styles from "./SuccessDeleteGameModal.module.scss";
import successDeleteGameIcon from "@/assets/img/successDelete.svg";
import arrowLeftIcon from "@/assets/icons/arrowCalendarLeft.svg";
import closeIcon from "@/assets/icons/closeIcon.svg";

interface SuccessDeleteGameModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: Record<string, any>;
}

const SuccessDeleteGameModalComponent = ({
  setIsOpen,
  params = {},
}: SuccessDeleteGameModalProps): JSX.Element => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.MOBILE_MEDIUM;

  const handleClose = () => {
    closeModal();
    navigate("/padel/games/my");
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Portal>
      <div className={styles.overlay}>
        <div className={styles.card}>
          {isMobile ? (
            <button className={styles.backButton} onClick={handleClose}>
              <img src={arrowLeftIcon} alt="назад" />
            </button>
          ) : (
            <button className={styles.closeButton} onClick={handleClose}>
              <img src={closeIcon} alt="закрыть" />
            </button>
          )}
          <img
            src={successDeleteGameIcon}
            alt="success delete game"
            className={styles.image}
          />
          <span className={styles.title}>Игра успешно удалена!</span>
          <Button onClickFunc={handleClose} newStyles={styles.button}>
            Вернуться в "Мои игры"
          </Button>
        </div>
      </div>
    </Portal>
  );
};

export default SuccessDeleteGameModalComponent;
export const SuccessDeleteGameModal = SuccessDeleteGameModalComponent;
